// extracted by mini-css-extract-plugin
export default {"name":"Name_name__Jkluz","design":"Name_design__iNuHy","avatar":"Name_avatar__81bWp","resumeButton":"Name_resumeButton__8klLz","resume":"Name_resume__qG4TJ"};